import React from 'react';

import ActionArrowRight from './action-arrow-right.svg';
import AddSVG from './add.svg';
import AddCircleSVG from './add-circle.svg';
import AddCircleFilledSVG from './add-circle-filled.svg';
import AddMembersSVG from './add-members.svg';
import AgileSVG from './agile.svg';
import AgileTaskSVG from './agile-task.svg';
import AIBulletSVG from './ai-bullet.svg';
import AIEnterSVG from './ai-button.svg';
import AIButtonStarsSVG from './ai-button-stars.svg';
import AIClearSVG from './ai-Clear-button.svg';
import AiCreateButtonSVG from './ai-create-button.svg';
import AiCreateButtonBetaSVG from './ai-create-button_beta.svg';
import AiMagicToolSVG from './ai-magic-tool.svg';
import AiPromptSVG from './ai-prompt.svg';
import AiQueryBotSVG from './ai-query-bot.svg';
import AirtableSVG from './airtable.svg';
import AlarmClockSVG from './alarm-clock.svg';
import AlertSVG from './alert.svg';
import AlignBottomSVG from './align-bottom.svg';
import AlignCenterHorizontalSVG from './align-center-horizontal.svg';
import AlignCenterVerticalSVG from './align-center-vertical.svg';
import AlignLeftSVG from './align-left.svg';
import AlignRightSVG from './align-right.svg';
import AlignTopSVG from './align-top.svg';
import ApprovalSVG from './approval.svg';
import ArchiveSVG from './archive.svg';
import ArchiveWhiteSVG from './archive-white.svg';
import ArrowDownSVG from './arrow-down.svg';
import ArrowDownTwoSVG from './arrow-down-2.svg';
import ArrowInSVG from './arrow-in.svg';
import ArrowLeftTwoSVG from './arrow-left-2.svg';
import ArrowOutSVG from './arrow-out.svg';
import ArrowRightSVG from './arrow-right.svg';
import ArrowRightTwoSVG from './arrow-right-2.svg';
import ArrowToAddSectionSVG from './arrow-to-addSection';
import ArrowTopSVG from './arrow-top.svg';
import ArrowUpSVG from './arrow-up.svg';
import ArrowUpTwoSVG from './arrow-up-2.svg';
import AssignTaskSVG from './assign-task.svg';
import AttachmentSVG from './attachment.svg';
import AttachmentAltSVG from './attachment-alt.svg';
import AudioSpeakerSVG from './audio-speaker.svg';
import AutomationSVG from './automation.svg';
import BackArrowSVG from './back-arrow.svg';
import BellSVG from './bell.svg';
import BillableSVG from './billable.svg';
import BlankTaskSVG from './blanktask.svg';
import BlockQuoteSVG from './block-quote.svg';
import BlueCircleSVG from './blue-circle.svg';
import BoardSVG from './board.svg';
import BoardOneSVG from './board-one.svg';
import BoldSVG from './bold.svg';
import BookOpenSVG from './book-open.svg';
import BookmarkSVG from './bookmark.svg';
import BookmarkFilledSVG from './bookmark-filled.svg';
import BookmarkOutlineSVG from './bookmark-outline.svg';
import BookmarkRemoveSVG from './bookmark-remove.svg';
import BoxStarSVG from './box-star.svg';
import BugSVG from './bug.svg';
import BulletedListSVG from './bulleted-list.svg';
import CalculatorSVG from './calculator.svg';
import CalendarSVG from './calendar.svg';
import CalendarDashboardSVG from './calendar-dashboard.svg';
import CalendarDashedDateSVG from './calendar-dashed-date';
import CalendarLearnerSVG from './calendar-learner.svg';
import CalenderSVG from './calender.svg';
import CalloutSVG from './callout.svg';
import ChatSVG from './chat-svg';
import CheckSVG from './check.svg';
import CheckBoxSVG from './check-box.svg';
import CheckCircleSVG from './check-circle.svg';
import CheckThinSVG from './check-thin.svg';
import CheckboxSVG from './checkbox.svg';
import CheckboxMarkCompleteCheckedSVG from './checkbox-mark-complete-checked.svg';
import CheckboxMarkCompleteUncheckedSVG from './checkbox-mark-complete-unchecked.svg';
import ChevronDownSVG from './chevron-down.svg';
import ChevronDownFilledSVG from './chevron-down-filled.svg';
import ChevronLeftSVG from './chevron-left.svg';
import ChevronRightSVG from './chevron-right.svg';
import CircleSVG from './circle.svg';
import CircleCheckboxSVG from './circle-checkbox.svg';
import ClipboardSVG from './clip-board.svg';
import ClipboardListSVG from './clipboard-list.svg';
import ClockSVG from './clock.svg';
import CloseSVG from './close.svg';
import CloudDownloadSVG from './cloud-download.svg';
import CloudDownloadOpenSVG from './cloud-download-open.svg';
import CodeSVG from './code.svg';
import CollapseSVG from './collapse.svg';
import CollateralSVG from './collateral.svg';
import ColorPickerSVG from './color-picker.svg';
import ColorToolSVG from './color-tool.svg';
import ComingSoonSVG from './coming-soon.svg';
import CommentSVG from './comment.svg';
import CommentTwoSVG from './comment-2.svg';
import CommentAltSVG from './comment-alt.svg';
import CommentsSVG from './comments.svg';
import CommentsOneSVG from './comments-1.svg';
import ConnectorSVG from './connector.svg';
import CopySVG from './copy.svg';
import CreationSVG from './creation.svg';
import CreditCardSVG from './credit-card.svg';
import CRMContactSVG from './crm-contact.svg';
import CsvSVG from './csv.svg';
import CursorSVG from './cursor.svg';
import CustomDateSvg from './custom-date.svg';
import CustomEmailSvg from './custom-email.svg';
import CustomEpicSVG from './custom-epic.svg';
import CustomMultiSelectSvg from './custom-multiselect.svg';
import CustomNumberSvg from './custom-number.svg';
import CustomPersonSvg from './custom-person.svg';
import CustomPhoneSvg from './custom-phone.svg';
import CustomSelectSvg from './custom-select.svg';
import CustomSprintSVG from './custom-sprint.svg';
import CustomTextSvg from './custom-text.svg';
import CustomTypeSVG from './custom-type.svg';
import CustomUrlSvg from './custom-url.svg';
import CustomizeSVG from './customize.svg';
import CustomizeSettingsSVG from './customize-settings.svg';
import DashDashedSVG from './dash-dashed.svg';
import DashedDottedSVG from './dash-dotted.svg';
import DashDrawSVG from './dash-draw.svg';
import DashedSolidSVG from './dash-solid.svg';
import DashboardSVG from './dashboard.svg';
import DashboardBulbSVG from './dashboard-bulb.svg';
import DashedLineSVG from './dashedLine.svg';
import DateSVG from './date.svg';
import DateDashedSVG from './date-dashed.svg';
import DeadlineSVG from './deadline.svg';
import DeleteSVG from './delete.svg';
import DeleteWhiteSVG from './delete-white.svg';
import DescriptionSVG from './description.svg';
import DesignSVG from './design.svg';
import DesignnCreativeSVG from './design-creative.svg';
import DocumentSVG from './document.svg';
import DragSVG from './drag.svg';
import DrawSVG from './draw.svg';
import DropDownSVG from './drop-down.svg';
import DualEllipses from './dual-ellipses.svg';
import DuplicateSVG from './duplicate.svg';
import EditSVG from './edit.svg';
import EditHideSVG from './edit-hide.svg';
import EditPencilSVG from './edit-pencil.svg';
import EducationSVG from './education.svg';
import EmailSVG from './email.svg';
import EmailAtTheRateSVG from './email-at-the-rate.svg';
import EmailTwoSVG from './email-two.svg';
import EmbedSVG from './embed.svg';
import EmbedViewSVG from './embedview.svg';
import EmojiSVG from './emoji.svg';
import EmojiSmileSVG from './emoji-smile.svg';
import EmptyStateSVG from './empty-state.svg';
import EnterPromptSVG from './enter-prompt.svg';
import EnvelopeSVG from './envelope.svg';
import EpicSVG from './epic.svg';
import Epic2SVG from './epic-2.svg';
import ErrorSVG from './error.svg';
import ExpandSVG from './expand.svg';
import ExpandArrowSVG from './expand-arrow.svg';
import ExternalLinkSVG from './external-link.svg';
import EyeSVG from './eye.svg';
import EyeAltSVG from './eye-alt.svg';
import EyeHideSVG from './eye-hide.svg';
import EyeUnhideSVG from './eye-unhide.svg';
import Eye2SVG from './eye2.svg';
import FacebookSVG from './facebook.svg';
import FigmaSVG from './figma.svg';
import FileSVG from './file.svg';
import FileAttachmentSVG from './file-attachment.svg';
import FileErrorSVG from './file-error.svg';
import FilesSVG from './files.svg';
import FilterSVG from './filter.svg';
import FilterTickMarkSVG from './filter-tick-mark.svg';
import FinanceSVG from './finance.svg';
import FinanceOnboardSVG from './finance-onboard.svg';
import FlagSVG from './flag.svg';
import FlameIconSVG from './flame.svg';
import FlamePopoverSVG from './flame-popover.svg';
import FolderSVG from './folder.svg';
import FolderAltSVG from './folder-alt.svg';
import FormSVG from './form.svg';
import FreezeColumnSVG from './freeze-column.svg';
import FreeTableSVG from './freeze-table.svg';
import FullScreenSVG from './full-screen.svg';
import GanttSVG from './gantt.svg';
import GanttDashboardSVG from './gantt-dashboard.svg';
import GavelSVG from './gavel.svg';
import GettingStartedOneSVG from './getting-started-1.svg';
import GettingStartedTwoSVG from './getting-started-2.svg';
import GithubSVG from './github.svg';
import GlassesSVG from './glasses.svg';
import GlobalTaskSVG from './globaltask.svg';
import GlobeSVG from './globe.svg';
import GoogleSVG from './google.svg';
import GoogleDocsSVG from './googledocs.svg';
import GoogleSheetsSVG from './googlesheets.svg';
import GoogleSlidesSVG from './googleslides.svg';
import GridSVG from './grid.svg';
import HadeSvg from './hade.svg';
import HandSVG from './hand-svg';
import HashSVG from './hash.svg';
import HeadingOneSVG from './heading-one.svg';
import HeadingThreeSVG from './heading-three.svg';
import HeadingTwoSVG from './heading-two.svg';
import HeartSVG from './heart.svg';
import HeartFilledSVG from './heart-filled.svg';
import HeartOutlineSVG from './heart-outline.svg';
import HelpSVG from './Help.svg';
import HomeSVG from './home.svg';
import HomeFilledSVG from './home-filled.svg';
import HustlerSVG from './hustler.svg';
import ImageSVG from './image.svg';
import ImportSVG from './import.svg';
import InfoSVG from './info.svg';
import ItSVG from './information-technology.svg';
import InsertLeftSVG from './insert-left.svg.tsx';
import InserRightSVG from './insert-right.svg';
import ItalicSVG from './italic.svg';
import LabelSVG from './label.svg';
import LeaderSVG from './leader.svg';
import ArrowLeftSVG from './left-arrow.svg';
import LeftArrowCircleSVG from './left-arrow-circle.svg';
import LegalSVG from './legal.svg';
import LegalOnboardSVG from './legal-onboarding.svg';
import LessonSVG from './lesson.svg';
import LevelCircleSVG from './level-circle.svg';
import LineSVG from './line.svg';
import LinearScaleSVG from './linear-scale.svg';
import LinkSvg from './link.svg';
import LinkFileSVG from './link-file.svg';
import LinkTwoSVG from './link-two.svg';
import LinkedinSVG from './linkedin.svg';
import ListSVG from './list.svg';
import LmsMenuSVG from './lms-menu.svg';
import LockedSVG from './locked.svg';
import LogOutSvg from './logout.svg';
import LucySVG from './lucy.svg';
import MailSVG from './mail.svg';
import SearchMailSvg from './mail-search-svg';
import ManageMembersSVG from './manage-members.svg';
import ManageWorkspacesSVG from './manage-workspaces.svg';
import Marketing from './marketing.svg';
import MarketingOnboardSVG from './marketing-onboard.svg';
import MasterSVG from './master.svg';
import MediaPlaySVG from './media-play.svg';
import MembersSVG from './members.svg';
import MenuSVG from './menu-icon.svg';
import MinusSVG from './minus.svg';
import MiroSVG from './miro.svg';
import ModuleAddSVG from './module-add.svg';
import ModuleSelectSVG from './module-select.svg';
import MoreSVG from './more.svg';
import MoreVertSVG from './more-vert.svg';
import MoveSVG from './move.svg';
import MoveTaskSVG from './movetask.svg';
import MultiSelectSVG from './multi-select.svg';
import MultipleChoiceSVG from './multiple-choice.svg';
import MyTaskSVG from './mytask.svg';
import NavArrowLeftSVG from './nav-left-arrow.svg';
import NavArrowRightSVG from './nav-right-arrow.svg';
import NewbieSVG from './newbie.svg';
import NextMediaSVG from './next-media.svg';
import NoAvatarSVG from './no-avatar.svg';
import NoFillSVG from './no-fill.svg';
import NoteSVG from './note.svg';
import NotionSVG from './notion.svg';
import NumberSVG from './number.svg';
import NumberedListSVG from './numbered-list.svg';
import OperationsSVG from './operations.svg';
import OtherSVG from './other.svg';
import ParagraphSVG from './paragraph.svg';
import PauseMediaSVG from './pause-media.svg';
import PersonSVG from './person.svg';
import PersonalSVG from './personal.svg';
import PhoneSVG from './phone.svg';
import PieChartSVG from './piechart.svg';
import PinSVG from './pin.svg';
import PinFilledSVG from './pin-filled.svg';
import PlayCircleSVG from './play-circle.svg';
import PlayMediaSVG from './play-media.svg';
import PlusSVG from './plus.svg';
import PlusCircleSVG from './plus-circle.svg';
import PlayCircleFilledSVG from './plus-circle.svg';
import PreRevenueSVG from './pre-revenue.svg';
import PreSeedSVG from './pre-seed.svg';
import PrevMediaSVG from './prev-media.svg';
import PrioritySVG from './priority.svg';
import PriorityFlagSVG from './priority-flag.svg';
import PrivateSVG from './private.svg';
import ProductSVG from './product.svg';
import ProfileImageSVG from './profile-image.svg';
import ProfileImageTwoSVG from './profile-image-two.svg';
import ProjectManagmentSVG from './project-managment.svg';
import QuizSVG from './quiz.svg';
import QuizDocumentsSVG from './quizdocument.svg';
import RadioBoxSVG from './radio-box.svg';
import RedoSVG from './redo.svg';
import RefreshSvg from './refresh-svg';
import ReloadSVG from './reload.svg';
import RenameSVG from './rename.svg';
import ReplySVG from './reply.svg';
import ReplyAllSVG from './reply-all.svg';
import RestoreSVG from './restore.svg';
import RightArrowCircleSVG from './right-arrow-circle.svg';
import RoundedLockedSVG, { RoundedLockedProps } from './rounded-locked.svg';
import SalesSVG from './sales.svg';
import SalesnCrmSVG from './sales-crm.svg';
import SaveAltSVG from './save-alt.svg';
import SearchSVG from './search.svg';
import SearchFilterSVG from './search-filter-svg';
import SeedBeyondSVG from './seed-beyond.svg';
import SelectSVG from './select.svg';
import SendChatQuestionSVG from './SendChatQuestion.svg';
import SettingsSVG from './settings.svg';
import SettingsFilledSVG from './settings-filled.svg';
import ShareSVG from './share.svg';
import ShareOneSVG from './share-1.svg';
import ShareTwoSVG from './share-2.svg';
import ShareAltSVG from './share-alt.svg';
import SharedSVG from './shared.svg';
import ShrinkArrowSVG from './shink-arrow.svg';
import ShoppingCartSVG from './shoppingcart.svg';
import ShortTextSVG from './short-text.svg';
import SidebarCloseSVG from './sidebar-close.svg';
import SidebarWorkspaceSVG from './sidebar-workspace.svg';
import SingleChoiceSVG from './single-choice.svg';
import SketchNoteLogoSVG from './sketchnote-logo.svg';
import SketchNoteLogoTwoSVG from './sketchnote-logo-two.svg';
import SketchNoteLogoWithTextSVG from './sketchnote-logo-withtext.svg';
import SlackSVG from './slack.svg';
import SmileySVG from './smiley.svg';
import SmileyPlainSVG from './smiley-plain.svg';
import SoftwareDevelopmentSVG from './software-development.svg';
import SortSVG from './sort.svg';
import SortAscSVG from './sort-asc.svg';
import SortDescSVG from './sort-desc.svg';
import Sort2SVG from './sort2.svg';
import SplitSVG from './split.svg';
import SquareSVG from './square.svg';
import StarSVG from './star.svg';
import StarFilledSVG from './star-filled.svg';
import StarRatingSVG from './star-rating.svg';
import StartBoardSVG from './start-board.svg';
import StartDocumentSVG from './start-document.svg';
import StartListSVG from './start-list.svg';
import StartTemplateStoreSVG from './start-template-store.svg';
import StartTimerSVG from './start-timer.svg';
import StartWhiteBoardSVG from './start-whiteboard.svg';
import StopCircleSVG from './stop-circle.svg';
import StopTimerSVG from './stop-timer.svg';
import StrikethroughSVG from './strikethrough.svg';
import SubTaskSVG from './sub-task.svg';
import SubtaskSVG from './subtask.svg';
import SubtaskCircleSVG from './subtask-circle.svg';
import SupportSVG from './support.svg';
import { SVGComponentProps } from './svg.types';
import SwapSVG from './swap.svg';
import TableSVG from './table.svg';
import { Table2SVG } from './table2.svg';
import TagsSVG from './tags.svg';
import TaskSVG from './task.svg';
import TaskHistoryCommentSVG from './taskHistory-comment.svg';
import TaskHistoryDateSVG from './taskHistory-date.svg';
import TaskHistoryDefaultSVG from './taskHistory-default.svg';
import TaskHistoryFieldtaskSVG from './taskHistory-fieldtask.svg';
import TaskHistoryFlagtaskSVG from './taskHistory-flagtask.svg';
import TaskHistoryMoveSVG from './taskHistory-move.svg';
import TaskHistoryMovetaskSVG from './taskHistory-movetask.svg';
import TaskHistoryNameSVG from './taskHistory-name.svg';
import TaskHistoryPrioritytSVG from './taskHistory-priority.svg';
import TaskHistoryRemoveSVG from './taskHistory-remove.svg';
import TaskHistorySubtaskSVG from './taskHistory-subtask.svg';
import TaskHistoryTaskSVG from './taskHistory-task.svg';
import TaskHistorytaskAssigneeSVG from './taskHistory-taskAssignee.svg';
import TaskHistorytaskAttachmentSVG from './taskHistory-taskAttachment.svg';
import TaskHistorytaskCompleteSVG from './taskHistory-taskcomplete.svg';
import TaskHistoryTimerSVG from './taskHistory-timer.svg';
import TaskHistoryTimerAltSVG from './taskHistory-timer-alt.svg';
import TaskHistoryUpvoteSVG from './taskHistory-upvote.svg';
import TaskHistoryWatchTaskSVG from './taskHistory-watchtask.svg';
import TemplateTaskSVG from './tasktemaplate.svg';
import TemplateStoreSVG from './template-store.svg';
import TemplateStoreNewSVG from './template-store-new.svg';
import TextSVG from './text.svg';
import TextAlignCenterSVG from './text-align-center.svg';
import TextAlignJustifySVG from './text-align-justify.svg';
import TextAlignLeftSVG from './text-align-left.svg';
import TextAlignRightSVG from './text-align-right.svg';
import TextBubbleSVG from './text-bubble.svg';
import TickMarkSVG from './tickmark.svg';
import TickMarkThinSVG from './tickmark-thin.svg';
import TimeHourglassSVG from './time-estimate.svg';
import TimerSVG from './timer.svg';
import TimeSheetSVG from './timesheet.svg';
import TitleContentSVG from './title-content.svg';
import TitleContentImageSVG from './title-content-image.svg';
import TodoLiSVG from './todo-li.svg';
import TrackedTimeClockSVG from './tracked-time-clock.svg';
import TrashSVG from './trash.svg';
import TriangleSVG from './triangle.svg';
import TwitterSVG from './twitter.svg';
import UnderlineSVG from './underline.svg';
import UnlockedSVG from './unlocked.svg';
import UpcomingDeadlineDateSVG from './upcoming-deadline-date.svg';
import UpdateSVG from './update.svg';
import UploadCloudSVG from './uploadCloud.svg';
import UpvoteSVG from './upvote.svg';
import UserSVG from './user.svg';
import UserStorySVG from './user-story.svg';
import VideoSVG from './video.svg';
import ViewSVG from './view.svg';
import VisibilitySVG from './visibility.svg';
import WarningSVG from './warning.svg';
import WelcomeHelpSVG from './welcome-help.svg';
import WhiteBoardSVG from './whiteboard.svg';
import WhiteBoardAttachment from './whiteboard-attachment.svg';
import WhiteBoardBoxSVG from './whiteboard-box.svg';
import WhiteboardBrushSVG from './whiteboard-brush.svg';
import WhiteBoardCircleSVG from './whiteboard-circle.svg';
import WhiteBoardCommentSVG from './whiteboard-comment.svg';
import WhiteBoardEllipseSVG from './whiteboard-ellipse.svg';
import WhiteBoardEraserSVG from './whiteboard-eraser.svg';
import WhiteboardFileSVG from './whiteboard-file.svg';
import WhiteboardImageSVG from './whiteboard-image.svg';
import WhiteboardLessonSVG from './whiteboard-lesson.svg';
import WhiteBoardLinkSVG from './whiteboard-link.svg';
import WhiteBoardLockSVG from './whiteboard-lock.svg';
import WhiteBoardMarkerSVG from './whiteboard-marker.svg';
import WhiteBoardRectangleSVG from './whiteboard-rectangle';
import WhiteboardStamp from './whiteboard-stamp.svg';
import WhiteboardTapeSVG from './whiteboard-tape.svg';
import WhiteboardTemplateSVG from './whiteboard-template.svg';
import WhiteBoardTriangleSVG from './whiteboard-triangle.svg';
import WhiteboardTextSVG from './whiteboardText.svg';
import WikiSVG from './wiki.svg';
import WorksheetSVG from './worksheet.svg';
import WorkspaceSVG from './workspace.svg';
import YellowCircleSVG from './yellow-circle.svg';
import YoutubeSVG from './youtube.svg';
export type IconProps = SVGComponentProps;

export const ReloadIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <ReloadSVG {...otherProps} />
);
export const ReminderIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <ReminderIcon {...otherProps} />
);
export const RightArrowIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <ArrowRightSVG {...otherProps} />
);
export const LeftArrowIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <ArrowLeftSVG {...otherProps} />
);
export const MessageIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <CheckSVG {...otherProps} />
);
export const CheckIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <CheckSVG {...otherProps} />
);
export const CheckThinIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <CheckThinSVG {...otherProps} />
);
export const ClockIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <ClockSVG {...otherProps} />
);
export const CloseIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <CloseSVG {...otherProps} />
);
export const CommentsIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <CommentsSVG {...otherProps} />
);
export const ChevronDownIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <ChevronDownSVG {...otherProps} />
);
export const ChevronDownFilledIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <ChevronDownFilledSVG {...otherProps} />
);
export const LockedIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <LockedSVG {...otherProps} />
);
export const AddIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <AddSVG {...otherProps} />
);
export const AddCircleIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <AddCircleSVG {...otherProps} />
);
export const AddCircleFilledIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <AddCircleFilledSVG {...otherProps} />
);
export const SearchIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <SearchSVG {...otherProps} />
);
export const ShoppingCartIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <ShoppingCartSVG {...otherProps} />
);
export const FlagIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <FlagSVG {...otherProps} />
);
export const CreationIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <CreationSVG {...otherProps} />
);
export const AgileIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <AgileSVG {...otherProps} />
);
export const CsvIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <CsvSVG {...otherProps} />
);
export const MoreIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <MoreSVG {...otherProps} />
);
export const MoreVertIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <MoreVertSVG {...otherProps} />
);
export const ExpandIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <ExpandSVG {...otherProps} />
);
export const CollateralIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <CollateralSVG {...otherProps} />
);
export const UserIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <UserSVG {...otherProps} />
);
export const MembersIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <MembersSVG {...otherProps} />
);
export const AddMembersIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <AddMembersSVG {...otherProps} />
);
export const MoveIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <MoveSVG {...otherProps} />
);
export const ArchiveIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <ArchiveSVG {...otherProps} />
);
export const DeleteIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <DeleteSVG {...otherProps} />
);
export const DocumentIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <DocumentSVG {...otherProps} />
);
export const LessonIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <LessonSVG {...otherProps} />
);
export const DownArrowIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <ArrowDownSVG {...otherProps} />
);
export const UpcomingDeadlineDateIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <UpcomingDeadlineDateSVG {...otherProps} />
);
export const LinkIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <LinkSvg {...otherProps} />
);
export const CollapseIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <CollapseSVG {...otherProps} />
);
export const AlertIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <AlertSVG {...otherProps} />
);
export const CheckCircle = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <CheckCircleSVG {...otherProps} />
);
export const BookmarkIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <BookmarkSVG {...otherProps} />
);
export const BookOpenIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <BookOpenSVG {...otherProps} />
);
export const NewbieIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <NewbieSVG {...otherProps} />
);
export const HustlerIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <HustlerSVG {...otherProps} />
);
export const MasterIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <MasterSVG {...otherProps} />
);
export const LeaderIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <LeaderSVG {...otherProps} />
);
export const InfoIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <InfoSVG {...otherProps} />
);
export const RoundedLockedIcon = ({ ...otherProps }: RoundedLockedProps): JSX.Element => (
  <RoundedLockedSVG {...otherProps} />
);
export const FlameIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <FlameIconSVG {...otherProps} />
);
export const PreRevenueIcon = (): JSX.Element => <PreRevenueSVG />;
export const PreSeedIcon = (): JSX.Element => <PreSeedSVG />;
export const SeedBeyondIcon = (): JSX.Element => <SeedBeyondSVG />;
export const GoogleIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <GoogleSVG {...otherProps} />
);
export const AirtableIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <AirtableSVG {...otherProps} />
);
export const NotionIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <NotionSVG {...otherProps} />
);

export const LevelCircleIcon = (): JSX.Element => <LevelCircleSVG />;
export const TopArrowIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <ArrowTopSVG {...otherProps} />
);
export const BookmarkRemoveIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <BookmarkRemoveSVG {...otherProps} />
);

export const NavArrowLeftIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <NavArrowLeftSVG {...otherProps} />
);
export const NavArrowRightIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <NavArrowRightSVG {...otherProps} />
);
export const BookmarkOutlineIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <BookmarkOutlineSVG {...otherProps} />
);
export const ArrowInIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <ArrowInSVG {...otherProps} />
);
export const ArrowOutIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <ArrowOutSVG {...otherProps} />
);
export const SearchFilterIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <SearchFilterSVG {...otherProps} />
);
export const RefreshIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <RefreshSvg {...otherProps} />
);
export const ShareIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <ShareSVG {...otherProps} />
);
export const ShareAltIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <ShareAltSVG {...otherProps} />
);
export const SearchMailIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <SearchMailSvg {...otherProps} />
);
export const CloudDownloadIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <CloudDownloadSVG {...otherProps} />
);
export const FacebookIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <FacebookSVG {...otherProps} />
);
export const LinkedinIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <LinkedinSVG {...otherProps} />
);
export const TwitterIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <TwitterSVG {...otherProps} />
);
export const ClipboardIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <ClipboardSVG {...otherProps} />
);
export const FilterIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <FilterSVG {...otherProps} />
);
export const ActionArrowRightIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <ActionArrowRight {...otherProps} />
);
export const HomeIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <HomeSVG {...otherProps} />
);
export const HomeIconFilled = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <HomeFilledSVG {...otherProps} />
);
export const DualEllipsesIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <DualEllipses {...otherProps} />
);
export const ChevronRightIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <ChevronRightSVG {...otherProps} />
);

export const ChevronLeftIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <ChevronLeftSVG {...otherProps} />
);
export const MediaPlayIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <MediaPlaySVG {...otherProps} />
);
export const UpdateIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <UpdateSVG {...otherProps} />
);
export const BookmarkFilledIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <BookmarkFilledSVG {...otherProps} />
);
export const ExpandArrowIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <ExpandArrowSVG {...otherProps} />
);
export const DashboardBulbIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <DashboardBulbSVG {...otherProps} />
);

export const NoAvatar = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <NoAvatarSVG {...otherProps} />
);
export const Bold = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <BoldSVG {...otherProps} />
);
export const Underline = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <UnderlineSVG {...otherProps} />
);
export const Italic = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <ItalicSVG {...otherProps} />
);
export const EmojiIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <EmojiSVG {...otherProps} />
);
export const StrikethroughIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <StrikethroughSVG {...otherProps} />
);
export const CommentsOneIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <CommentsOneSVG {...otherProps} />
);
export const TextIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <TextSVG {...otherProps} />
);
export const HeadingOneIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <HeadingOneSVG {...otherProps} />
);
export const HeadingTwoIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <HeadingTwoSVG {...otherProps} />
);
export const HeadingThreeIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <HeadingThreeSVG {...otherProps} />
);
export const BlockQuoteIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <BlockQuoteSVG {...otherProps} />
);
export const CodeIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <CodeSVG {...otherProps} />
);
export const CalendarLearnerIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <CalendarLearnerSVG {...otherProps} />
);
export const TableIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <TableSVG {...otherProps} />
);
export const CalloutIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <CalloutSVG {...otherProps} />
);
export const CalculatorIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <CalculatorSVG {...otherProps} />
);
export const ArrowRightTwoIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <ArrowRightTwoSVG {...otherProps} />
);
export const ArrowLeftTwoIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <ArrowLeftTwoSVG {...otherProps} />
);
export const ArrowUpTwoIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <ArrowUpTwoSVG {...otherProps} />
);
export const ArrowDownTwoIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <ArrowDownTwoSVG {...otherProps} />
);

export const GettingStartedOneIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <GettingStartedOneSVG {...otherProps} />
);

export const GettingStartedTwoIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <GettingStartedTwoSVG {...otherProps} />
);

export const BlueCircleIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <BlueCircleSVG {...otherProps} />
);

export const DeadlineIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <DeadlineSVG {...otherProps} />
);

export const SettingsIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <SettingsSVG {...otherProps} />
);
export const SettingsAltIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <SettingsSVG {...otherProps} />
);
export const SettingsFilledIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <SettingsFilledSVG {...otherProps} />
);
export const DragIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <DragSVG {...otherProps} />
);
export const ProfileImageIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <ProfileImageSVG {...otherProps} />
);
export const ProfileImageTwoIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <ProfileImageTwoSVG {...otherProps} />
);

export const ModuleAddIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <ModuleAddSVG {...otherProps} />
);
export const LogOutIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <LogOutSvg {...otherProps} />
);

export const ModuleSelectIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <ModuleSelectSVG {...otherProps} />
);

export const YellowCircleIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <YellowCircleSVG {...otherProps} />
);
export const SaveAltIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <SaveAltSVG {...otherProps} />
);
export const AudioSpeakerIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <AudioSpeakerSVG {...otherProps} />
);
export const FlamePopover = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <FlamePopoverSVG {...otherProps} />
);
export const CalenderIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <CalenderSVG {...otherProps} />
);
export const ColorPickerIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <ColorPickerSVG {...otherProps} />
);
export const EditIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <EditSVG {...otherProps} />
);
export const EditPencilIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <EditPencilSVG {...otherProps} />
);
export const GlassesIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <GlassesSVG {...otherProps} />
);
export const DuplicateIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <DuplicateSVG {...otherProps} />
);
export const SketchNoteLogoIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <SketchNoteLogoSVG {...otherProps} />
);
export const SketchNoteLogoTwoIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <SketchNoteLogoTwoSVG {...otherProps} />
);
export const LeftArrowCircleIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <LeftArrowCircleSVG {...otherProps} />
);
export const TextBubbleIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <TextBubbleSVG {...otherProps} />
);
export const RightArrowCircleIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <RightArrowCircleSVG {...otherProps} />
);
export const BoardIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <BoardSVG {...otherProps} />
);
export const TickMarkIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <TickMarkSVG {...otherProps} />
);
export const TickMarkThinIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <TickMarkThinSVG {...otherProps} />
);
export const MenuIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <MenuSVG {...otherProps} />
);
export const EnvelopeIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <EnvelopeSVG {...otherProps} />
);

export const ComingSoonIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <ComingSoonSVG {...otherProps} />
);
export const AiMagicToolIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <AiMagicToolSVG {...otherProps} />
);
export const RestoreIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <RestoreSVG {...otherProps} />
);
export const TaskIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <TaskSVG {...otherProps} />
);
export const TodoLiIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <TodoLiSVG {...otherProps} />
);
export const SelectIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <SelectSVG {...otherProps} />
);
export const CheckboxMarkCompleteCheckedIcon = ({
  ...otherProps
}: SVGComponentProps): JSX.Element => <CheckboxMarkCompleteCheckedSVG {...otherProps} />;
export const CheckboxMarkCompleteUncheckedIcon = ({
  ...otherProps
}: SVGComponentProps): JSX.Element => <CheckboxMarkCompleteUncheckedSVG {...otherProps} />;
export const CheckboxIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <CheckboxSVG {...otherProps} />
);
export const MultiSelectIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <MultiSelectSVG {...otherProps} />
);
export const PersonIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <PersonSVG {...otherProps} />
);
export const ErrorIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <ErrorSVG {...otherProps} />
);
export const BulletedList = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <BulletedListSVG {...otherProps} />
);
export const NumberedList = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <NumberedListSVG {...otherProps} />
);
export const BoardOne = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <BoardOneSVG {...otherProps} />
);
export const DateIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <DateSVG {...otherProps} />
);
export const UnlockedIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <UnlockedSVG {...otherProps} />
);
export const ImageIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <ImageSVG {...otherProps} />
);
export const RedoIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <RedoSVG {...otherProps} />
);
export const CommmentTwoIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <CommentTwoSVG {...otherProps} />
);
export const WorkspaceIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <WorkspaceSVG {...otherProps} />
);

export const AttachmentIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <AttachmentSVG {...otherProps} />
);
export const AttachmentAltIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <AttachmentAltSVG {...otherProps} />
);

export const SidebarCloseIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <SidebarCloseSVG {...otherProps} />
);

export const FileAttachmentIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <FileAttachmentSVG {...otherProps} />
);

export const AssignTaskIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <AssignTaskSVG {...otherProps} />
);
export const CopyIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <CopySVG {...otherProps} />
);

export const WhiteBoardIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <WhiteBoardSVG {...otherProps} />
);

export const WhiteboardTemplateIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <WhiteboardTemplateSVG {...otherProps} />
);

export const SlackIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <SlackSVG {...otherProps} />
);
export const FilterTickMarkIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <FilterTickMarkSVG {...otherProps} />
);

export const LabelIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <LabelSVG {...otherProps} />
);

export const TagsIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <TagsSVG {...otherProps} />
);

export const ListIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <ListSVG {...otherProps} />
);

export const HadeIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <HadeSvg {...otherProps} />
);
export const EditHideIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <EditHideSVG {...otherProps} />
);

export const EyeUnhideIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <EyeUnhideSVG {...otherProps} />
);
// export const EyeHideIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
//   <EyeHideSVG {...otherProps} />
// );

export const MinusIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <MinusSVG {...otherProps} />
);

export const DrawIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <DrawSVG {...otherProps} />
);

export const CircleCheckboxIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <CircleCheckboxSVG {...otherProps} />
);

export const ConnectorIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <ConnectorSVG {...otherProps} />
);
export const WhiteboardTextIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <WhiteboardTextSVG {...otherProps} />
);
export const NoteIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <NoteSVG {...otherProps} />
);
export const CursorIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <CursorSVG {...otherProps} />
);
export const DashDashedIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <DashDashedSVG {...otherProps} />
);
export const DashDottedIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <DashedDottedSVG {...otherProps} />
);
export const DashSolidIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <DashedSolidSVG {...otherProps} />
);
export const DashDrawIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <DashDrawSVG {...otherProps} />
);

export const NoFillIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <NoFillSVG {...otherProps} />
);

export const CircleIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <CircleSVG {...otherProps} />
);

export const FullScreenIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <FullScreenSVG {...otherProps} />
);

export const EmojiFaceWithSmileleIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <EmojiSmileSVG {...otherProps} />
);

export const FinanceIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <FinanceSVG {...otherProps} />
);

export const DesignIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <DesignSVG {...otherProps} />
);
export const MarketingIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <Marketing {...otherProps} />
);
export const ProductIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <ProductSVG {...otherProps} />
);
export const LegalIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <LegalSVG {...otherProps} />
);

export const CreditCardIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <CreditCardSVG {...otherProps} />
);
export const SalesIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <SalesSVG {...otherProps} />
);
export const PersonalIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <PersonalSVG {...otherProps} />
);

export const WhiteboardImageIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <WhiteboardImageSVG {...otherProps} />
);

export const WhiteBoardFileIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <WhiteboardFileSVG {...otherProps} />
);

export const WhiteBoardEraserIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <WhiteBoardEraserSVG {...otherProps} />
);

export const WhiteBoardStampIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <WhiteboardStamp {...otherProps} />
);

export const WhiteBoardLockIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <WhiteBoardLockSVG {...otherProps} />
);
export const HandIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <HandSVG {...otherProps} />
);

export const WhiteBoardMarkerIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <WhiteBoardMarkerSVG {...otherProps} />
);

export const WhiteBoardBoxIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <WhiteBoardBoxSVG {...otherProps} />
);

export const EyeAltIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <EyeAltSVG {...otherProps} />
);
export const Eye2Icon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <Eye2SVG {...otherProps} />
);

export const EyeHideIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <EyeHideSVG {...otherProps} />
);

export const WhiteBoardAttachmentIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <WhiteBoardAttachment {...otherProps} />
);

export const TextAlignLeftIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <TextAlignLeftSVG {...otherProps} />
);
export const TextAlignCenterIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <TextAlignCenterSVG {...otherProps} />
);
export const TextAlignRightIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <TextAlignRightSVG {...otherProps} />
);
export const TextAlignJustifyIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <TextAlignJustifySVG {...otherProps} />
);
export const SquareIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <SquareSVG {...otherProps} />
);
export const TriangleIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <TriangleSVG {...otherProps} />
);
export const LineIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <LineSVG {...otherProps} />
);
export const GanttIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <GanttSVG {...otherProps} />
);
export const HeartIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <HeartSVG {...otherProps} />
);
export const ShortTextIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <ShortTextSVG {...otherProps} />
);
export const ParagraphIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <ParagraphSVG {...otherProps} />
);
export const LinearScaleIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <LinearScaleSVG {...otherProps} />
);
export const DropDownIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <DropDownSVG {...otherProps} />
);
export const StarRatingIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <StarRatingSVG {...otherProps} />
);
export const RadioBox = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <RadioBoxSVG {...otherProps} />
);
export const CheckBox = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <CheckBoxSVG {...otherProps} />
);
export const GridIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <GridSVG {...otherProps} />
);
export const SharedIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <SharedSVG {...otherProps} />
);

export const GithubIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <GithubSVG {...otherProps} />
);

export const PrevMediaIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <PrevMediaSVG {...otherProps} />
);

export const NextMediaIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <NextMediaSVG {...otherProps} />
);

export const PlayMediaIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <PlayMediaSVG {...otherProps} />
);

export const PauseMediaIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <PauseMediaSVG {...otherProps} />
);
export const DateDashedIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <DateDashedSVG {...otherProps} />
);

export const TimeHourglassIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <TimeHourglassSVG {...otherProps} />
);

export const PlayCircle = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <PlayCircleSVG {...otherProps} />
);

export const StopCircle = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <StopCircleSVG {...otherProps} />
);

export const BillableIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <BillableSVG {...otherProps} />
);

export const DescriptionIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <DescriptionSVG {...otherProps} />
);

export const GanttDashboardIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <GanttDashboardSVG {...otherProps} />
);
export const CalendarDashboardIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <CalendarDashboardSVG {...otherProps} />
);
export const HeartFilledIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <HeartFilledSVG {...otherProps} />
);

export const HeartOutlineIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <HeartOutlineSVG {...otherProps} />
);

export const SmileyPlainIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <SmileyPlainSVG {...otherProps} />
);
export const SmileyIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <SmileySVG {...otherProps} />
);
export const DashboardIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <DashboardSVG {...otherProps} />
);

export const DashedLineIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <DashedLineSVG {...otherProps} />
);

export const EmailAtTheRateIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <EmailAtTheRateSVG {...otherProps} />
);
export const PhoneIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <PhoneSVG {...otherProps} />
);
export const GlobeIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <GlobeSVG {...otherProps} />
);

export const PieChartIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <PieChartSVG {...otherProps} />
);

export const WhiteboardBrushIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <WhiteboardBrushSVG {...otherProps} />
);

export const WhiteboardCommentIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <WhiteBoardCommentSVG {...otherProps} />
);

export const WhiteboardEllipseIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <WhiteBoardEllipseSVG {...otherProps} />
);

export const WhiteboardRectangleIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <WhiteBoardRectangleSVG {...otherProps} />
);

export const WhiteboardTriangleIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <WhiteBoardTriangleSVG {...otherProps} />
);

export const WhiteboardTapeIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <WhiteboardTapeSVG {...otherProps} />
);

export const WhiteboardCircleIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <WhiteBoardCircleSVG {...otherProps} />
);

export const WhiteboardLinkIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <WhiteBoardLinkSVG {...otherProps} />
);

export const WhiteboardLessonIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <WhiteboardLessonSVG {...otherProps} />
);

export const MailIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <MailSVG {...otherProps} />
);

export const FormIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <FormSVG {...otherProps} />
);

export const CustomTextIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <CustomTextSvg {...otherProps} />
);
export const CustomNumberIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <CustomNumberSvg {...otherProps} />
);
export const CustomSelectIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <CustomSelectSvg {...otherProps} />
);
export const CustomMultiselectIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <CustomMultiSelectSvg {...otherProps} />
);
export const CustomDateIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <CustomDateSvg {...otherProps} />
);
export const CustomPersonIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <CustomPersonSvg {...otherProps} />
);
export const CustomUrlIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <CustomUrlSvg {...otherProps} />
);
export const CustomEmailIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <CustomEmailSvg {...otherProps} />
);
export const CustomPhoneIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <CustomPhoneSvg {...otherProps} />
);
export const ImportIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <ImportSVG {...otherProps} />
);
export const FigmaIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <FigmaSVG {...otherProps} />
);
export const YoutubeIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <YoutubeSVG {...otherProps} />
);
export const GoogleSheetsIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <GoogleSheetsSVG {...otherProps} />
);
export const GoogleDocsIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <GoogleDocsSVG {...otherProps} />
);
export const GoogleSlidesIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <GoogleSlidesSVG {...otherProps} />
);
export const MiroIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <MiroSVG {...otherProps} />
);
export const CommentIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <CommentSVG {...otherProps} />
);
export const CommentAltIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <CommentAltSVG {...otherProps} />
);
export const SplitIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <SplitSVG {...otherProps} />
);
export const SubtaskCircleIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <SubtaskCircleSVG {...otherProps} />
);
export const PriorityIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <PrioritySVG {...otherProps} />
);
export const PriorityFlagIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <PriorityFlagSVG {...otherProps} />
);
export const TitleContentIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <TitleContentSVG {...otherProps} />
);
export const TitleContentImageIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <TitleContentImageSVG {...otherProps} />
);
export const QuizIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <QuizSVG {...otherProps} />
);
export const VideoIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <VideoSVG {...otherProps} />
);
export const ArrowToAddSectionIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <ArrowToAddSectionSVG {...otherProps} />
);
export const UploadCloudIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <UploadCloudSVG {...otherProps} />
);

export const TaskHistorySubtaskIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <TaskHistorySubtaskSVG {...otherProps} />
);
export const TaskHistoryTaskIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <TaskHistoryTaskSVG {...otherProps} />
);
export const TaskHistoryNameIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <TaskHistoryNameSVG {...otherProps} />
);
export const TaskHistoryUpvoteIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <TaskHistoryUpvoteSVG {...otherProps} />
);
export const TaskHistoryMoveIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <TaskHistoryMoveSVG {...otherProps} />
);
export const TaskHistoryRemoveIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <TaskHistoryRemoveSVG {...otherProps} />
);
export const TaskHistoryDefaultIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <TaskHistoryDefaultSVG {...otherProps} />
);
export const TaskHistoryWatchTaskIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <TaskHistoryWatchTaskSVG {...otherProps} />
);
export const TaskHistoryFlagtaskIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <TaskHistoryFlagtaskSVG {...otherProps} />
);
export const TaskHistoryMovetaskIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <TaskHistoryMovetaskSVG {...otherProps} />
);
export const TaskHistoryFieldtaskIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <TaskHistoryFieldtaskSVG {...otherProps} />
);
export const TaskHistorytaskCompleteIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <TaskHistorytaskCompleteSVG {...otherProps} />
);
export const TaskHistorytaskAssigneeIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <TaskHistorytaskAssigneeSVG {...otherProps} />
);
export const TaskHistorytaskAttachmentIcon = ({
  ...otherProps
}: SVGComponentProps): JSX.Element => <TaskHistorytaskAttachmentSVG {...otherProps} />;
export const TaskHistoryPriorityIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <TaskHistoryPrioritytSVG {...otherProps} />
);
export const TaskHistoryCommentIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <TaskHistoryCommentSVG {...otherProps} />
);
export const TaskHistoryTimerIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <TaskHistoryTimerSVG {...otherProps} />
);
export const TaskHistoryTimerAltIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <TaskHistoryTimerAltSVG {...otherProps} />
);
export const TaskHistoryDateIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <TaskHistoryDateSVG {...otherProps} />
);
export const ArrowUpIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <ArrowUpSVG {...otherProps} />
);
export const Table2Icon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <Table2SVG {...otherProps} />
);
export const MyTaskIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <MyTaskSVG {...otherProps} />
);
export const GlobalTaskIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <GlobalTaskSVG {...otherProps} />
);
export const BlankTaskIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <BlankTaskSVG {...otherProps} />
);
export const TemplateTaskIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <TemplateTaskSVG {...otherProps} />
);
export const WorksheetIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <WorksheetSVG {...otherProps} />
);
export const BoxStarIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <BoxStarSVG {...otherProps} />
);
export const StartBoardIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <StartBoardSVG {...otherProps} />
);
export const StartWhiteBoardIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <StartWhiteBoardSVG {...otherProps} />
);
export const StartDocumentIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <StartDocumentSVG {...otherProps} />
);
export const StartListIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <StartListSVG {...otherProps} />
);
export const StartTemplateStoreIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <StartTemplateStoreSVG {...otherProps} />
);
export const AlignLeft = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <AlignLeftSVG {...otherProps} />
);
export const AlignRight = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <AlignRightSVG {...otherProps} />
);
export const AlignCenterHorizontal = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <AlignCenterHorizontalSVG {...otherProps} />
);
export const AlignCenterVertical = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <AlignCenterVerticalSVG {...otherProps} />
);
export const AlignTop = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <AlignTopSVG {...otherProps} />
);
export const AlignBottom = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <AlignBottomSVG {...otherProps} />
);
export const EmptyStateIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <EmptyStateSVG {...otherProps} />
);
export const UserStoryIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <UserStorySVG {...otherProps} />
);
export const BugIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <BugSVG {...otherProps} />
);
export const AgileTaskIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <AgileTaskSVG {...otherProps} />
);
export const EpicIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <EpicSVG {...otherProps} />
);
export const PlayCircleFilledIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <PlayCircleFilledSVG {...otherProps} />
);
export const LinkFileIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <LinkFileSVG {...otherProps} />
);
export const ExternalLinkIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <ExternalLinkSVG {...otherProps} />
);
export const SwapIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <SwapSVG {...otherProps} />
);
export const TimerIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <TimerSVG {...otherProps} />
);
export const QuizDocumentIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <QuizDocumentsSVG {...otherProps} />
);
export const LucyIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <LucySVG {...otherProps} />
);

export const SketchNoteLogoWithTextIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <SketchNoteLogoWithTextSVG {...otherProps} />
);

export const AlarmClockIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <AlarmClockSVG {...otherProps} />
);
export const Epic2Icon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <Epic2SVG {...otherProps} />
);
export const CustomTypeIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <CustomTypeSVG {...otherProps} />
);
export const CustomSprintIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <CustomSprintSVG {...otherProps} />
);
export const CustomEpicIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <CustomEpicSVG {...otherProps} />
);

export const CloudDownloadOpenIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <CloudDownloadOpenSVG {...otherProps} />
);
export const ReplyIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <ReplySVG {...otherProps} />
);
export const ReplyAllIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <ReplyAllSVG {...otherProps} />
);
export const ClipboardListIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <ClipboardListSVG {...otherProps} />
);
export const ArchiveWhiteIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <ArchiveWhiteSVG {...otherProps} />
);
export const DeleteWhiteIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <DeleteWhiteSVG {...otherProps} />
);

export const PrivateIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <PrivateSVG {...otherProps} />
);

export const FolderIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <FolderSVG {...otherProps} />
);
export const PlusIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <PlusSVG {...otherProps} />
);
export const PlusCircleIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <PlusCircleSVG {...otherProps} />
);

export const TrashIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <TrashSVG {...otherProps} />
);

export const CalendarDashedDateIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <CalendarDashedDateSVG {...otherProps} />
);

export const MultipleChoiceIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <MultipleChoiceSVG {...otherProps} />
);

export const SingleChoiceIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <SingleChoiceSVG {...otherProps} />
);
export const CustomizeSettingsIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <CustomizeSettingsSVG {...otherProps} />
);

export const ChatIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <ChatSVG {...otherProps} />
);
export const LmsMenuIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <LmsMenuSVG {...otherProps} />
);

export const WikiIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <WikiSVG {...otherProps} />
);

export const FileErrorIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <FileErrorSVG {...otherProps} />
);

export const CRMContactIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <CRMContactSVG {...otherProps} />
);

export const SendChatQuestionIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <SendChatQuestionSVG {...otherProps} />
);
export const HelpIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <HelpSVG {...otherProps} />
);
export const AutomationIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <AutomationSVG {...otherProps} />
);
export const SubtaskIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <SubtaskSVG {...otherProps} />
);
export const StartTimerIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <StartTimerSVG {...otherProps} />
);
export const StopTimerIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <StopTimerSVG {...otherProps} />
);

export const AiQueryBotIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <AiQueryBotSVG {...otherProps} />
);

export const ManageMembersIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <ManageMembersSVG {...otherProps} />
);
export const ManageWorkspacesIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <ManageWorkspacesSVG {...otherProps} />
);
export const BackArrowIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <BackArrowSVG {...otherProps} />
);
export const HashIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <HashSVG {...otherProps} />
);
export const FolderAltIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <FolderAltSVG {...otherProps} />
);

export const SalesnCrmIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <SalesnCrmSVG {...otherProps} />
);

export const FinanceOnboardIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <FinanceOnboardSVG {...otherProps} />
);
export const DesignnCreativeIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <DesignnCreativeSVG {...otherProps} />
);
export const ProjectManagmentIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <ProjectManagmentSVG {...otherProps} />
);
export const ItIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <ItSVG {...otherProps} />
);
export const LegalOnboardIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <LegalOnboardSVG {...otherProps} />
);
export const EducationIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <EducationSVG {...otherProps} />
);

export const SoftwareDevelopmentIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <SoftwareDevelopmentSVG {...otherProps} />
);
export const OperationsIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <OperationsSVG {...otherProps} />
);
export const MarketingOnboardIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <MarketingOnboardSVG {...otherProps} />
);
export const SupportIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <SupportSVG {...otherProps} />
);
export const ApprovalIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <ApprovalSVG {...otherProps} />
);
export const OtherIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <OtherSVG {...otherProps} />
);
export const TimeSheetIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <TimeSheetSVG {...otherProps} />
);
export const WarningIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <WarningSVG {...otherProps} />
);

export const WelcomeHelpIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <WelcomeHelpSVG {...otherProps} />
);
export const AICreateButton = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <AiCreateButtonSVG {...otherProps} />
);
export const AICreateButtonBeta = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <AiCreateButtonBetaSVG {...otherProps} />
);
export const AiPromptIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <AiPromptSVG {...otherProps} />
);
export const EnterPromptIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <EnterPromptSVG {...otherProps} />
);
export const AIBulletIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <AIBulletSVG {...otherProps} />
);
export const AIButtonStars = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <AIButtonStarsSVG {...otherProps} />
);
export const AIEnterIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <AIEnterSVG {...otherProps} />
);
export const AIClearIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <AIClearSVG {...otherProps} />
);
export const MoveTaskIcon = ({ ...otherProps }: SVGComponentProps): JSX.Element => (
  <MoveTaskSVG {...otherProps} />
);
export const InsertRight = InserRightSVG;
export const SortAsc = SortAscSVG;
export const InsertLeft = InsertLeftSVG;
export const SortDesc = SortDescSVG;
export const FreezeTable = FreeTableSVG;
export const FreezeColumn = FreezeColumnSVG;
export const NumberIcon = NumberSVG;
export const EmailIcon = EmailSVG;
export const LinkTwoIcon = LinkTwoSVG;
export const EmailTwoIcon = EmailTwoSVG;
export const ShareOneIcon = ShareOneSVG;
export const ShareTwoIcon = ShareTwoSVG;
export const EmbedIcon = EmbedSVG;
export const EmbedViewIcon = EmbedViewSVG;
export const SortIcon = SortSVG;
export const Sort2Icon = Sort2SVG;
export const GavelIcon = GavelSVG;
export const EyeIcon = EyeSVG;
export const UpvoteIcon = UpvoteSVG;
export const VisibilityIcon = VisibilitySVG;
export const ShrinkArrowIcon = ShrinkArrowSVG;
export const SubTaskIcon = SubTaskSVG;
export const ViewIcon = ViewSVG;
export const ColorToolIcon = ColorToolSVG;
export const PinFilledIcon = PinFilledSVG;
export const PinIcon = PinSVG;
export const StarFilledIcon = StarFilledSVG;
export const StarIcon = StarSVG;
export const FileIcon = FileSVG;
export const FilesIcon = FilesSVG;
export const CalendarIcon = CalendarSVG;
export const CustomizeIcon = CustomizeSVG;
export const SidebarWorkspaceIcon = SidebarWorkspaceSVG;
export const TemplateStoreIcon = TemplateStoreSVG;
export const TemplateStoreNewIcon = TemplateStoreNewSVG;
export const TrackedTimeClockIcon = TrackedTimeClockSVG;
export const RenameIcon = RenameSVG;
export const BellIcon = BellSVG;
